export const getCookie = async (cookieName) => {
  const url = `${process.env.NEXT_PUBLIC_API_URL}/cookie?cookieName=${cookieName}`
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Credential: 'include',
    },
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  const data = await response.json()
  return data
}
